/**
 * Utility functions for employee data manipulation
 */

/**
 * Find an employee ID by their name
 * @param {string} name - The employee name to search for
 * @param {Array} employees - Array of employee objects with id and name properties
 * @returns {number|string|null} - The employee ID or null if not found
 */
export const getEmployeeIdByName = (name, employees) => {
	if (!name || !Array.isArray(employees)) return null;
	const employee = employees.find((emp) => emp.name === name);
	return employee ? employee.id : null;
};

/**
 * Find an employee name by their ID
 * @param {number|string} id - The employee ID to search for
 * @param {Array} employees - Array of employee objects with id and name properties
 * @returns {string|null} - The employee name or null if not found
 */
export const getEmployeeNameById = (id, employees) => {
	if (id === null || id === undefined || !Array.isArray(employees)) return null;
	const employee = employees.find((emp) => emp.id === id);
	return employee ? employee.name : null;
};

/**
 * Convert an array of employee names to IDs
 * @param {Array} names - Array of employee names
 * @param {Array} employees - Array of employee objects with id and name properties
 * @returns {Array} - Array of employee IDs (filtered to remove null values)
 */
export const convertEmployeeNamesToIds = (names, employees) => {
	if (!Array.isArray(names) || !Array.isArray(employees)) return [];
	return names.map((name) => getEmployeeIdByName(name, employees)).filter(Boolean);
};

/**
 * Convert an array of employee IDs to names
 * @param {Array} ids - Array of employee IDs
 * @param {Array} employees - Array of employee objects with id and name properties
 * @returns {Array} - Array of employee names (filtered to remove null values)
 */
export const convertEmployeeIdsToNames = (ids, employees) => {
	if (!Array.isArray(ids) || !Array.isArray(employees)) return [];
	return ids.map((id) => getEmployeeNameById(id, employees)).filter(Boolean);
};
